import utils from "utils";

export function WindowRoomReducer(state = [], action) {
    switch (action.type) {
        case "GET_WINDOW_ROOMS":
            return action.payload.result;
        case "ADD_WINDOW_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function WindowStyleReducer(state = [], action) {
    switch (action.type) {
        case "GET_WINDOW_STYLES":
            return action.payload.result;
        case "ADD_WINDOW_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function WindowDesignReducer(state = [], action) {
    switch (action.type) {
        case "GET_WINDOW_DESIGNS":
            return action.payload.result;
        case "ADD_WINDOW_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function WindowOptionReducer(state = { colours: [], extras: [], glass: [] }, action) {
    switch (action.type) {
        case "GET_WINDOW_OPTIONS":
            return {
                colours: action.payload.result.colours,
                extras: action.payload.result.extras,
                glass: action.payload.result.glass
            };
        case "ADD_WINDOW_TO_LIST":
            return { colours: [], extras: [], glass: [] };
        default:
            return state;
    }
}

// we don't reset this one once the window is finished because we keep showing the WERs afterward
export function WindowWerReducer(state = {}, action) {
    switch (action.type) {
        case "GET_WINDOW_OPTIONS":
            var glass = action.payload.result.glass;
            var wer = {};
            if (glass.length > 0) {
                wer = utils.makeArrayIntoHash(glass[0].availableWers, "id");
            }

            return { ...state, ...wer };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/window_reducers.js